import "./index.less";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Menu from "../Menu/index";
import Header from "../Header/index";
import UHFFooter from "../UHFFooter";
import MessageBar from "../MessageBar/index";
import { useMessageBarClasses } from "../MessageBar/MessageBarIntent";
import { getLocalStorage, getParameter } from "@/utilities/common";
import { observer, useStore } from "@/utilities/storeHook";
import BZASpinner from "../BZAspinner";
import BZAToast from "../BZAToast";
import eventBus from "@/utilities/eventBus";
import ExpiryPage from "@/features/ErrorPage/expiryPage";

import { useTranslation } from "react-i18next";

const PageLayout = () => {
  const { t } = useTranslation();
  // const isAuthenticated = useIsAuthenticated();
  const routerParams = Number(getParameter("cid")) || 0;
  const { commonStore, errorStore, userStore } = useStore();
  const { showMessageBar, showProcedureMessageBar, progressHidden, toastInfo } = commonStore;
  const [showTip, setShowTip] = useState<boolean>(showProcedureMessageBar);
  const [showMenu, setShowMenu] = useState<boolean>(true);
  const AID: any = Number(getParameter("aid"));
  const isAuthenticated = getLocalStorage("isAuthenticated") === "true";

  useEffect(() => {
    if (AID) {
      eventBus.off("accountStatus");
      eventBus.on("accountStatus", ({ accountStatus }) => {
        setShowMenu(accountStatus !== 2);
      });
    } else {
      setShowMenu(true);
    }
  }, [AID]);
  return (
    <div className="c-PageLayout" style={{ top: `${showMessageBar === false ? 97 - 37 : 97}px` }}>
      <a className="skip-to-main" href="#appMain" onClick={(e) => { e.preventDefault(); document.getElementById("appMain")?.focus(); }}>
        {t("Header.skipToContent")}
      </a>
      <ExpiryPage />
      {toastInfo && Object.keys(toastInfo).length > 0 ? <BZAToast isShow={toastInfo.show} status={toastInfo.status} message={toastInfo.message} /> : null}      <div className="header">
        {getLocalStorage("userInfo") ? <Header /> : null}
      </div>
      {routerParams
        ? <>
          {showMessageBar && errorStore.errormessage !== ""
            ? <MessageBar
              intent={1}
              messageInfoTitle={"error"}
              messageInfo={errorStore.errormessage}
              className={useMessageBarClasses.container}
            />
            : null}
          <div className="c-PageLayout-index ms-Grid-row" aria-label="Page Layout" style={{ top: `${showMessageBar && errorStore.errormessage !== "" ? 97 : 97 - 37}px` }}>
            {showMenu ? <Menu /> : null}
            <main className="appMainWrap ms-Grid-col ms-sm12 ms-md12 ms-lg4 full-screen" aria-label="Page Content">
              <BZASpinner loading={progressHidden} />
              {showProcedureMessageBar && errorStore.procedureErrormessage !== "" ? <MessageBar intent={1} messageInfoTitle={"error"} messageInfo={errorStore.procedureErrormessage} show={showTip} onDismiss={() => setShowTip(!showTip)}></MessageBar> : null}
              <div id="appMain" tabIndex={-1} className="appMain" style={{
                height: `calc(100vh - ${showMessageBar && errorStore.errormessage !== "" ? 130 : 63}px)`,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden" // 防止父容器滚动导致的抖动
              }}>
                <div style={{
                  flex: "1 1 auto",
                  overflowY: "auto",
                  overflowX: "hidden",
                  minHeight: 0,
                  WebkitOverflowScrolling: "touch",
                  overscrollBehavior: "none", // 完全禁用过度滚动
                  overscrollBehaviorY: "none",
                  scrollBehavior: "auto",
                  position: "relative",
                  transform: "translateZ(0)",
                  willChange: "scroll-position",
                  // 添加更多防抖动的CSS属性
                  backfaceVisibility: "hidden",
                  perspective: "1000px"
                }}>
                  <Outlet />
                </div>
                <UHFFooter />
              </div>
            </main>
          </div>
        </>
        : <>{isAuthenticated && getLocalStorage("userInfo")
          ? <div className="c-PageLayout-index ms-Grid-row" aria-label="Page Layout" style={{ top: 60 }}>
            <main className="appMainWrap" aria-label="Page Content">
              <BZASpinner loading={progressHidden} />
              <div id="appMain" tabIndex={-1} className="appMain" style={{
                height: "calc(100vh - 60px)",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden" // 防止父容器滚动导致的抖动
              }}>
                <div style={{
                  flex: "1 1 auto",
                  overflowY: "auto",
                  overflowX: "hidden",
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  <Outlet />
                </div>
                <UHFFooter />
              </div>
            </main>
          </div>
          : <Outlet />
        }
        </>
      }
    </div>
  );
};

export default observer(PageLayout);
